import React from 'react'
import {
  DataTable,
  SkeletonLoader,
  SKELETON_LOADER_VARIANT_ONWHITE,
  NoResults,
  ButtonAction,
  SpacingVertical,
  ModalConfirm
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import {
  manageRecipientsState,
  modalDeleteRecipientsState
} from '../recoil/state/manageRecipients'
import {
  deleteRecipientsCallback,
  getQueuedEmailRecipientsCallback,
  getSmartPlanningSuggestedDateCallback,
  getTotalSendingTimeCallback
} from '../recoil/callbacks/callbacks'
import Pagination from './Pagination'
import { useHistory } from 'react-router-dom'
import { timeAndCountState } from '../recoil/state/campaign'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_FEATURES,
  storeGet
} from 'mailup-react-helpers'

const TableRecipients = () => {
  const intl = useIntl()
  const history = useHistory()
  const {
    orderBy,
    orderDescending,
    items,
    isSearch,
    totalItems,
    pageNumber,
    pageSize
  } = useRecoilValue(manageRecipientsState)

  const [{ show }, setModalDeleteRecipient] = useRecoilState(
    modalDeleteRecipientsState
  )
  const setManageRecipients = useSetRecoilState(manageRecipientsState)
  const resetModalDeleteRecipient = useResetRecoilState(
    modalDeleteRecipientsState
  )
  const getQueuedEmailRecipients = useRecoilCallback(
    getQueuedEmailRecipientsCallback,
    []
  )
  const deleteRecipients = useRecoilCallback(deleteRecipientsCallback, [])
  const getTotalSendingTime = useRecoilCallback(getTotalSendingTimeCallback, [])
  const { queued } = useRecoilValue(timeAndCountState)
  const getSmartPlanningSuggestedDate = useRecoilCallback(
    getSmartPlanningSuggestedDateCallback,
    []
  )

  const smartPlanningFeature =
    storeGet(STORE_KEY_FEATURES).indexOf('smartPlanning') >= 0
  const account = storeGet(STORE_KEY_ACCOUNT)
  const showSmartPlanning =
    smartPlanningFeature &&
    account.IdOffer !== 3 &&
    account.IdOffer !== 2 &&
    account.IdOffer !== 6 &&
    !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA - SOLOSMS-LIGHT

  const handleClickSort = () => {
    setManageRecipients(prev => ({
      ...prev,
      orderBy: prev.orderBy === 'asc' ? 'desc' : 'asc'
    }))
    getQueuedEmailRecipients()
  }

  const handleClickDeleteItem = item => {
    setModalDeleteRecipient(prev => ({
      show: true,
      idRecipient: item.IdUser
    }))
  }

  const handleConfirmDelete = () => {
    deleteRecipients(queued).then(resp => {
      if (resp) {
        if (queued === 1) {
          history.push('/messages/email/sendstatus/campaigns')
        } else {
          if (pageNumber > 1) {
            const r = totalItems % pageSize
            if (r === 1) {
              setManageRecipients(prev => ({
                ...prev,
                pageNumber: prev.pageNumber - 1
              }))
              getQueuedEmailRecipients()
              getTotalSendingTime()
              if (showSmartPlanning) {
                getSmartPlanningSuggestedDate(true)
              }
            }
          } else {
            getQueuedEmailRecipients()
            getTotalSendingTime()
            if (showSmartPlanning) {
              getSmartPlanningSuggestedDate(true)
            }
          }
        }
      }
    })
  }

  return (
    <>
      <ModalConfirm
        show={show}
        title={intl.formatMessage({
          id: 'Load.Queue.AlertDelRecipientTitle'
        })}
        message={
          queued === 1
            ? intl.formatMessage({
                id: 'Load.Queue.AlertDelQueue'
              })
            : intl.formatMessage({
                id: 'Load.Queue.AlertDelRecipient'
              })
        }
        onClickCancel={resetModalDeleteRecipient}
        onClickConfirm={handleConfirmDelete}
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        data-mu-test='modal-delete-Recipient'
        variant='delete'
      />
      <SpacingVertical />
      {totalItems > 0 || isSearch ? (
        <>
          <DataTable
            sortable
            sortBy='Email'
            sortOrder={orderBy.toUpperCase()}
            onClickSort={handleClickSort}
            head={[
              {
                span: 10,
                content: intl.formatMessage({
                  id: 'Load.Queue.RecipientsResultsEmailLabel'
                }),

                sortId: 'Email',
                sortable: true
              },
              {
                span: 2,
                align: 'right'
              }
            ]}
            body={
              items &&
              items.map(item =>
                !isSearch
                  ? [
                      { content: item.Email },
                      {
                        content: (
                          <ButtonAction
                            type='delete'
                            onClick={() => handleClickDeleteItem(item)}
                            data-mu-test={`email-sending-queue-manage__btn-action--${item}`}
                          />
                        )
                      }
                    ]
                  : [
                      {
                        content: (
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        )
                      }
                    ]
              )
            }
          />
          <SpacingVertical />
          <Pagination />
        </>
      ) : (
        <NoResults
          text={
            intl.formatMessage({
              id: 'Load.Queue.NoRecipientsTitle'
            }) +
            ' ' +
            intl.formatMessage({
              id: 'Load.Queue.NoRecipientsDescription'
            })
          }
        />
      )}
    </>
  )
}

export default TableRecipients
